function cleanSegment(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

export function isDisplayCityValid(city: unknown): boolean {
  const value = cleanSegment(String(city ?? ''));
  if (!value) return false;
  return !/(федеральн\w*\s+округ|область|край)/i.test(value);
}

export function cityFallbackFromAddress(address: unknown): string | null {
  const raw = String(address ?? '').trim();
  if (!raw) return null;

  const segments = raw
    .split(',')
    .map(cleanSegment)
    .filter(Boolean)
    .reverse();

  for (const segment of segments) {
    if (segment === '—') continue;
    if (/(^|\s)россия($|\s)|федеральн\w*\s+округ|область|край/i.test(segment)) continue;
    if (/^\d{5,6}$/.test(segment)) continue;
    if (/^(ул\.?|улица|д\.?|дом|кв\.?|квартира|корп\.?|корпус|стр\.?|строение)\b/i.test(segment)) continue;
    return segment;
  }

  return null;
}

export function displayCityWithAddressFallback(city: unknown, address: unknown): string {
  const value = cleanSegment(String(city ?? ''));
  if (isDisplayCityValid(value)) return value;
  return cityFallbackFromAddress(address) ?? '—';
}

export function displayDirectionWithAddressFallback(params: {
  loadingCity?: unknown;
  unloadingCity?: unknown;
  loadingAddress?: unknown;
  unloadingAddress?: unknown;
  fallbackLabel?: string | null;
}): string {
  const from = displayCityWithAddressFallback(params.loadingCity, params.loadingAddress);
  const to = displayCityWithAddressFallback(params.unloadingCity, params.unloadingAddress);
  if (from !== '—' && to !== '—') return `${from} → ${to}`;
  if (from !== '—' || to !== '—') return [from, to].filter((value) => value !== '—').join(' → ');
  return params.fallbackLabel?.trim() || '—';
}
